import { TableBody } from "./TableBody";
import { TableColumnToggle } from "./TableColumnToggle";
import { TableFilters } from "./TableFilters";
import { TableFooter } from "./TableFooter";
import { TableHeader } from "./TableHeader";
import { TableRoot } from "./TableRoot";

export const Table = {
  Root: TableRoot,
  Header: TableHeader,
  Body: TableBody,
  Footer: TableFooter,
  ColumnToggle: TableColumnToggle,
  Filters: TableFilters,
};
